import React, { useEffect, ReactNode, useState, useRef } from "react";
import { Sidebar, Menu, MenuItem, SubMenu } from "react-pro-sidebar";
import Logo from "Assets/green-logo.svg";
import LayoutClasses from "./Layout.module.css";
import { MdOutlineEmail } from "react-icons/md";
import { IoSearchSharp } from "react-icons/io5";
import { FiBell } from "react-icons/fi";
import { IoMdPower } from "react-icons/io";
import { useLocation, NavLink, useNavigate } from "react-router-dom";
import avatar from "Assets/user.jpg";
import USFlag from "Assets/usflag.png";
import { Config } from "./Config";
import { IoSettings } from "react-icons/io5";
import swal from "sweetalert";
import StepperComp from "Components/Stepper/StepperComp";
import { useStore } from "Store";
import ReferModal from "Components/Referral/ReferModal";
interface LayoutProps {
    children: ReactNode;
}

const Layout: React.FC<LayoutProps> = ({ children }) => {
    const Navigate = useNavigate();
    const { Collapsed, setCollapsed, mainStatus } = useStore(
        (state: any) => state
    );
    const setShowReferModal = useStore((s: any) => s.setShowReferModal);
    const rightSideRef = useRef<HTMLDivElement>(null);
    const userMenuRef = useRef<HTMLDivElement>(null);

    const location = useLocation();
    const [isScrolled, setIsScrolled] = useState(false);
    const [userName, setUserName] = useState<string>("User");
    const [isUserMenuOpen, setIsUserMenuOpen] = useState(false);
    useEffect(() => {
        const handleResize = () => {
            if (window.innerWidth >= 1000) {
                setCollapsed(false);
            } else {
                setCollapsed(true);
            }
        };

        // Set initial state
        handleResize();

        window.addEventListener("resize", handleResize);

        // Clean up event listener on component unmount
        return () => {
            window.removeEventListener("resize", handleResize);
        };
    }, []);
    useEffect(() => {
        const handleScroll = () => {
            if (window.scrollY > 80) {
                setIsScrolled(true);
            } else {
                setIsScrolled(false);
            }
        };

        window.addEventListener("scroll", handleScroll);

        return () => {
            window.removeEventListener("scroll", handleScroll);
        };
    }, []);
    useEffect(() => {
        if (rightSideRef.current) {
            rightSideRef.current.scrollTo(0, 0);
        }
    }, [location]);

    // Load user display name from localStorage (stored as UserDetails)
    useEffect(() => {
        try {
            const s = localStorage.getItem("UserDetails");
            if (s) {
                const parsed = JSON.parse(s as string);
                const name =
                    parsed?.name ||
                    [parsed?.first_name, parsed?.last_name]
                        .filter(Boolean)
                        .join(" ") ||
                    parsed?.email ||
                    "User";
                setUserName(name);
            }
        } catch (e) {
            // ignore parse errors and keep default
        }
    }, []);

    // Close user menu on outside click
    useEffect(() => {
        const handleClickOutside = (event: MouseEvent) => {
            if (
                userMenuRef.current &&
                !userMenuRef.current.contains(event.target as Node)
            ) {
                setIsUserMenuOpen(false);
            }
        };

        document.addEventListener("mousedown", handleClickOutside);
        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, []);

    // Close user menu when navigating
    useEffect(() => {
        setIsUserMenuOpen(false);
    }, [location.pathname]);

    function checkPathExists(subMenu: any, pathname: any) {
        for (let i = 0; i < subMenu.length; i++) {
            if (subMenu[i].Link === pathname) {
                return true;
            }
        }
        return false;
    }

    const commonStyles = {
        padding: "5px",
        height: "40px",
        borderRadius: "10px",
        color: "rgba(255, 255, 255, 0.85)",
        [`&.active`]: {
            backgroundColor: "rgba(255,255,255,0.1)",
            color: "#5B52C4",
        },
        [`&:hover`]: {
            backgroundColor: "rgba(255, 255, 255, 0.1)",
            color: "#ffffff",
        },
    };
    const logoutHandler = () => {
        swal({
            title: "Are You sure you want to Sign out?",
            icon: "warning",
            className: LayoutClasses["logout-popup"],
            dangerMode: true,
            buttons: {
                cancel: {
                    text: "Cancel",
                    value: false,
                },
                catch: {
                    text: "Logout",
                    value: "Logout",
                    className: LayoutClasses["cancel"],
                },
            },
        }).then((value: any) => {
            switch (value) {
                case "Logout":
                    Navigate("/admin");
                    localStorage.clear();
                    break;
            }
        });
    };

    const goToProfile = () => {
        setIsUserMenuOpen(false);
        Navigate("/auth/settings");
    };

    const toggleUserMenu = () => setIsUserMenuOpen((prev) => !prev);
    return (
        <div className={LayoutClasses["Container"]}>
            <div className={LayoutClasses["SideNavWrapper"]}>
                <img
                    src={Logo}
                    alt="Logo"
                    style={{ width: Collapsed ? "3rem" : "12rem" }}
                />

                <Sidebar
                    backgroundColor="transparent"
                    collapsed={Collapsed}
                    collapsedWidth={"73px"}
                    width={"265px"}>
                    <Menu
                        closeOnClick={true}
                        rootStyles={{
                            margin: "5px 10px",
                        }}
                        menuItemStyles={{
                            button: ({ level, open }) => {
                                if (level == 1) {
                                    return {
                                        ...commonStyles,
                                        margin: !Collapsed
                                            ? "0.2rem 0"
                                            : " 0.2rem",
                                    };
                                }

                                return commonStyles;
                            },
                            icon: {
                                minWidth: Collapsed ? "40px" : "35px",
                                marginRight: "5px",
                                color: "rgba(255, 255, 255, 0.85)",
                            },
                            subMenuContent: {
                                background: "transparent",
                                margin: "0",
                                padding: "0 0 0 15px",
                            },
                        }}>
                        {[...Config]
                            .filter((item) => {
                                let status =
                                    mainStatus == "client_review" ||
                                    mainStatus == "e_filing";
                                if (status) {
                                    return item;
                                } else {
                                    return item.Name != "Review Document";
                                }
                            })
                            .map((item: any) => {
                                if (item.isMultiple) {
                                    return (
                                        <SubMenu
                                            key={item.Name}
                                            rootStyles={{
                                                margin: "5px 0",
                                                color: "rgba(255, 255, 255, 0.85)",
                                                [`&.active`]: {
                                                    backgroundColor: "#ffffff",
                                                    color: "#5B52C4",
                                                },
                                            }}
                                            label={item.Name}
                                            icon={
                                                <item.Icon
                                                    size={20}
                                                    className={
                                                        LayoutClasses["icon"]
                                                    }
                                                />
                                            }
                                            active={checkPathExists(
                                                item.subMenu,
                                                location.pathname
                                            )}>
                                            {item.subMenu.map(
                                                (dropdown: any) => (
                                                    <MenuItem
                                                        key={dropdown.Name}
                                                        rootStyles={{
                                                            marginTop: Collapsed
                                                                ? 0
                                                                : "0.2rem",
                                                            color: "rgba(255, 255, 255, 0.85)",
                                                            padding: 0,
                                                            height: "40px",
                                                            [`&.active`]: {
                                                                color: "#5B52C4",
                                                                backgroundColor:
                                                                    "#ffffff",
                                                            },
                                                        }}
                                                        active={location.pathname.includes(
                                                            dropdown.Link
                                                        )}
                                                        component={
                                                            <NavLink
                                                                to={
                                                                    dropdown.Link
                                                                }
                                                            />
                                                        }>
                                                        {dropdown.Name}
                                                    </MenuItem>
                                                )
                                            )}
                                        </SubMenu>
                                    );
                                } else {
                                    return (
                                        <MenuItem
                                            key={item.Name}
                                            rootStyles={{
                                                color: "rgba(255, 255, 255, 0.85)",
                                                marginBottom: "5px",
                                                [`&.active`]: {
                                                    backgroundColor: "#ffffff",
                                                    color: "#5B52C4",
                                                },
                                            }}
                                            active={location.pathname.includes(
                                                item.Link
                                            )}
                                            icon={
                                                <item.Icon
                                                    size={20}
                                                    className={
                                                        LayoutClasses["icon"]
                                                    }
                                                />
                                            }
                                            component={
                                                <NavLink to={item.Link} />
                                            }>
                                            {" "}
                                            {item.Name}
                                        </MenuItem>
                                    );
                                }
                            })}

                        <MenuItem
                            rootStyles={{
                                color: "rgba(255, 255, 255, 0.85)",
                                [`&.active`]: {
                                    backgroundColor: "#ffffff",
                                    color: "#5B52C4",
                                },
                                [`&:hover`]: {
                                    backgroundColor: "rgba(255, 255, 255, 0.1)",
                                    color: "#ffffff",
                                },
                            }}
                            onClick={logoutHandler}
                            icon={
                                <IoMdPower
                                    color="rgba(255, 255, 255, 0.85)"
                                    size={20}
                                />
                            }>
                            Logout
                        </MenuItem>
                    </Menu>
                </Sidebar>
            </div>
            <div ref={rightSideRef} className={LayoutClasses["RightSide"]}>
                {/* Top announcement bar with scrolling message */}
                <div className={LayoutClasses["TopAnnouncement"]}>
                    <div className={LayoutClasses["marquee"]} aria-hidden>
                        <p>
                            File your taxes today — get help now! Visit our
                            services or contact support for fast filing. File
                            your taxes today — get help now! Visit our services
                            or contact support for fast filing.
                        </p>
                    </div>
                </div>
                <div
                    className={`${LayoutClasses["TopNav"]} ${
                        isScrolled ? LayoutClasses["TopNav_scrolled"] : ""
                    }`}>
                    <div></div>
                    <div className={`${LayoutClasses["top-nav-right"]}`}>
                        <div className={LayoutClasses["contact-info"]}>
                            <p className={LayoutClasses["contact-email"]}>
                                <MdOutlineEmail />
                                <a href="mailto:contact@serenetax.com">
                                    contact@serenetax.com
                                </a>
                            </p>
                            <p className={LayoutClasses["contact-phone"]}>
                                <span className={LayoutClasses["phone-item"]}>
                                    <img
                                        src={USFlag}
                                        alt="US"
                                        className={
                                            LayoutClasses["contact-flag-small"]
                                        }
                                    />
                                    <a href="tel:+12627358874">262-735-8874</a>
                                </span>
                                <span className={LayoutClasses["phone-sep"]}>
                                    |
                                </span>
                                <span className={LayoutClasses["phone-item"]}>
                                    <img
                                        src={USFlag}
                                        alt="US"
                                        className={
                                            LayoutClasses["contact-flag-small"]
                                        }
                                    />
                                    <a href="tel:+12627358875">262-735-8875</a>
                                </span>
                            </p>
                        </div>
                        <button
                            className={LayoutClasses["refer-button"]}
                            onClick={() => {
                                if (setShowReferModal) setShowReferModal(true);
                            }}>
                            Refer a Friend
                        </button>
                        <div className={`${LayoutClasses["bell-icon"]}`}>
                            <FiBell size={20} />
                        </div>
                        <div
                            className={LayoutClasses["user-wrapper"]}
                            ref={userMenuRef}>
                            <button
                                type="button"
                                className={LayoutClasses["user-trigger"]}
                                onClick={toggleUserMenu}
                                aria-haspopup="menu"
                                aria-expanded={isUserMenuOpen}>
                                <span className={LayoutClasses["user-img"]}>
                                    <img
                                        src={avatar}
                                        alt="avatar"
                                        style={{
                                            width: "2.5rem",
                                            height: "2rem",
                                            borderRadius: "50%",
                                        }}
                                    />
                                </span>
                                <span className={LayoutClasses["user-name"]}>
                                    {userName}
                                </span>
                            </button>
                            {isUserMenuOpen ? (
                                <div
                                    className={
                                        LayoutClasses["user-dropdown"]
                                    }
                                    role="menu">
                                    <button
                                        type="button"
                                        onClick={goToProfile}
                                        role="menuitem">
                                        Profile
                                    </button>
                                    <button
                                        type="button"
                                        onClick={() => {
                                            setIsUserMenuOpen(false);
                                            logoutHandler();
                                        }}
                                        role="menuitem">
                                        Logout
                                    </button>
                                </div>
                            ) : null}
                        </div>
                    </div>
                </div>
                <StepperComp />
                {/* Global refer modal (renders when store.showReferModal is true) */}
                <ReferModal />
                {children}
            </div>
        </div>
    );
};

export default Layout;
